import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=ec5721ba&scoped=true"
import script from "./PaymentDetails.vue?vue&type=script&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetails.vue?vue&type=style&index=0&id=ec5721ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5721ba",
  null
  
)

export default component.exports